import React from 'react';
import EmptyBackground from '../EmptyBackground';
import { getFeature } from '../../../DaEditorWrapper/Features';
import { getLargestFullview } from '../../../DeviationViews/_helpers';
import { FIRST_IMAGE_FEATURE } from '../../../DaEditorWrapper/Features/firstImage';
import BackgroundImage from '../../BackgroundImage';
function getCoverImage(_a) {
    var textContent = _a.textContent, commission = _a.commission;
    if (textContent && textContent.html.type === 'draft') {
        var first = getFeature(FIRST_IMAGE_FEATURE, textContent.html.features);
        if (first) {
            return getLargestFullview(first.data.deviation);
        }
    }
    else if (commission) {
        if (commission.examples && commission.examples.length) {
            return getLargestFullview(commission.examples[0]);
        }
    }
}
export var CommissionStageBackground = function (_a) {
    var deviation = _a.deviation, _b = _a.height, height = _b === void 0 ? 0 : _b, _c = _a.width, width = _c === void 0 ? 0 : _c;
    var coverImage = getCoverImage(deviation);
    if (!coverImage) {
        return React.createElement(EmptyBackground, null);
    }
    var _d = coverImage.width, coverWidth = _d === void 0 ? 0 : _d, _e = coverImage.height, coverHeight = _e === void 0 ? 0 : _e, src = coverImage.src;
    var shouldBlur = coverHeight < height || coverWidth < width;
    return React.createElement(BackgroundImage, { src: src, blur: shouldBlur, fade: "full" });
};
CommissionStageBackground.displayName = 'CommissionStageBackground';
export default CommissionStageBackground;
//# sourceMappingURL=Commission.js.map